<template>
  <div class="pa-5">
    <LogoMain />
  </div>

  <v-spacer />

  <v-btn
    v-if="$authStore.isAuthenticated"
    class="mr-3"
    color="lightprimary"
    icon
    rounded="sm"
    size="small"
    variant="flat"
    @click="handleRefresh">
    <RefreshIcon
      size="22"
      stroke-width="1.5" />
  </v-btn>

  <v-menu
    :close-on-content-click="false"
    location="bottom">
    <template v-slot:activator="{ props }">
      <v-btn
        class="mr-3"
        color="lightprimary"
        icon
        rounded="sm"
        size="small"
        v-bind="props"
        variant="flat">
        <SunIcon
          size="22"
          stroke-width="1.5" />
      </v-btn>
    </template>
    <v-sheet
      elevation="12"
      rounded="md"
      width="200">
      <ThemeDropdown />
    </v-sheet>
  </v-menu>

  <v-btn
    v-if="$authStore.isAuthenticated"
    class="mr-5"
    color="lightprimary"
    icon
    rounded="sm"
    size="small"
    variant="flat"
    @click="handleLogout">
    <LogoutIcon
      size="22"
      stroke-width="1.5" />
  </v-btn>
</template>

<script lang="ts" setup>
import { LogoutIcon, RefreshIcon, SunIcon } from 'vue-tabler-icons';
import LogoMain from '@/layout/logo/LogoMain.vue';
import { msalService } from '@/config/useAuth';
import { useAuthStore } from '@/stores/auth';
import { useMetricsStore } from '@/stores/metrics';
import ThemeDropdown from '@/layout/horizontal-header/ThemeDropdown.vue';

const $authStore = useAuthStore();
const metricsStore = useMetricsStore();
const { logout } = msalService();

function handleLogout() {
  logout();
}

function handleRefresh() {
  metricsStore.refreshAllMetrics();
}
</script>
